import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { contentSelect, displayModalMessage } from 'common/actions/appActions';
import { autoPlaySelector, roadblockSelector } from 'selectors/appSelector';
import playingContentSelector from 'selectors/playingContentSelector';
import { userLocationSelector } from 'selectors/authenticationSelectors';
import whitelistSelector from 'selectors/whitelistSelector';
import { shallowCheckAuthentication } from 'lib/auth';
import { scrollTo } from 'lib/ui';
import { BucketLayout, ModalType } from 'enums';

const playerLocation = '/watch/player?id=';

export default (WrappedComponent) => {
    class Playable extends React.Component {
        constructor(props) {
            super(props);
            this.blackoutClickHandler = this.blackoutClickHandler.bind(this);
            this.clickHandler = this.clickHandler.bind(this);
        }

        blackoutClickHandler(event) {
            event.preventDefault();
            this.props.dispatch(displayModalMessage(ModalType.BLACKOUT_MAP, { content: this.props.content }));
        }

        clickHandler(event) {
            event.preventDefault();
            const {
                bucketId,
                content,
                dispatch,
                groupId,
                isHero,
                isMobile,
                placement,
                roadblock,
                router,
                routing = {},
                userAuth
            } = this.props;

            if (roadblock === true && content.type === 'event') {
                window.location = `/watch/roadblock?id=${content.id}`;
                return;
            }

            const enhancedContent = {
                ...content,
                bucketId,
                groupId,
                isHero,
                placement,
                userInitiated: true
            };
            if (shallowCheckAuthentication(content, userAuth, false)) {
                const { pathname } = (routing && routing.locationBeforeTransitions) || {};
                const onPlayerPage = (pathname.indexOf('/player') !== -1);
                // if you're not on the player page, route to it
                if (isHero !== true && !onPlayerPage) {
                    // if a user selects upcoming content, direct to the player page with the upcoming alert badge
                    const alertContent = (enhancedContent.status === 'upcoming') ? enhancedContent : null;
                    const query = {
                        id: content.id,
                        bucketId,
                        groupId
                    };
                    router.push({
                        pathname: '/player',
                        query,
                        state: { alertContent, placement, userInitiated: true }
                    });
                    return;
                } else if (isMobile === true && onPlayerPage) {
                    scrollTo(document.body, 0, 250);
                }
            }
            dispatch(contentSelect(enhancedContent));
        }

        render() {
            const { content, inWhitelist, isMobile, placement, userAuth } = this.props;
            const { source, subtitle, type } = content;
            const formattedSubtitle = (type === 'event') ? `${source} • ${subtitle}` : subtitle;
            let userAuthenticatedForContent = shallowCheckAuthentication(content, userAuth);

            // show keys all the time on mobile for authd content (unless whitelisted which allows playback on mobile)
            if (!inWhitelist && content.authTypes && isMobile === true) {
                userAuthenticatedForContent = false;
            }

            const newProps = {
                ...this.props,
                playerHref: `${playerLocation}${content.id}`,
                content: { ...this.props.content, placement, formattedSubtitle },
                selected: this.props.playingContent.id === content.id,
                userAuthenticatedForContent
            };
            return (
                <WrappedComponent
                    {...newProps}
                    blackoutClickHandler={this.blackoutClickHandler}
                    clickHandler={this.clickHandler}
                />
            );
        }
    }

    Playable.defaultProps = {
        featured: false,
        isMobile: false,
        layoutType: BucketLayout.DEFAULT,
        placement: 'unknown',
        playingContent: {}
    };

    Playable.propTypes = {
        bucketId: PropTypes.number,
        content: PropTypes.object,
        dispatch: PropTypes.func,
        inWhitelist: PropTypes.bool,
        groupId: PropTypes.number,
        isHero: PropTypes.bool,
        isMobile: PropTypes.bool,
        placement: PropTypes.string,
        playingContent: PropTypes.object,
        roadblock: PropTypes.bool,
        routing: PropTypes.object,
        router: PropTypes.object,
        userAuth: PropTypes.array
    };

    const mapStateToProps = (state) => {
        const { authentication = {}, routing } = state;

        return {
            routing,
            autoPlay: autoPlaySelector(state),
            inWhitelist: whitelistSelector(state),
            isMobile: state.app.isMobile,
            playingContent: playingContentSelector(state),
            roadblock: roadblockSelector(state),
            userAuth: authentication.authTypes,
            userLocation: userLocationSelector(state)
        };
    };

    return withRouter(connect(mapStateToProps)(Playable), { withRef: true });
};



// WEBPACK FOOTER //
// ./app/common/playable.js